// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Lottie from "lottie-react";

// const HeroSection = () => {
//   const navigate = useNavigate();

//   const handleHomeClick = () => {
//     navigate("/shop");
//   };

//   const [beeAnimation1, setBeeAnimation1] = useState(null);
//   const [beeAnimation2, setBeeAnimation2] = useState(null);
//   const [beeAnimation3, setBeeAnimation3] = useState(null);
//   const [mainImageLottie, setMainImageLottie] = useState(null);

//   useEffect(() => {
//     fetch("/assets/General/honeyBee.json")
//       .then((res) => res.json())
//       .then((data) => setBeeAnimation1(data))
//       .catch((err) => console.error("Error loading bee_1:", err));

//     fetch("/assets/General/honeyBee.json")
//       .then((res) => res.json())
//       .then((data) => setBeeAnimation2(data))
//       .catch((err) => console.error("Error loading bee_2:", err));

//     fetch("/assets/General/honeyBee.json")
//       .then((res) => res.json())
//       .then((data) => setBeeAnimation3(data))
//       .catch((err) => console.error("Error loading bee_3:", err));

//     fetch("/assets/General/homeBottom.json")
//       .then((res) => res.json())
//       .then((data) => setMainImageLottie(data))
//       .catch((err) => console.error("Error loading main image:", err));
//   }, []);

//   return (
//     <div className="relative mt-27 pb-10 md:pb-0 pt-5 md:pt-0 md:mt-0 md:min-h-screen bg-cream w-full flex flex-col md:flex-row items-center px-4 md:px-16 justify-between overflow-hidden">
      


//       {/* Background Images for Laptop View */}
// <div className="hidden md:block">
//   {/* Left Bottom Image */}
//   <img 
//     src="/assets/General/leftBottom.png" 
//     alt="Left Background" 
//     className="absolute left-0 bottom-0 w-40 lg:w-60 fadeInAnimation"
//   />

//   {/* Center Background Image */}
//   {/* <img 
//     src="/assets/General/path_bg.png" 
//     alt="Center Background" 
//     className="absolute left-1/2 transform -translate-x-1/2 top-5 right-60 w-48 lg:w-150 fadeInAnimation"
//   /> */}
// </div>

// <div className="block md:hidden h-[20px] w-full"></div>

//       {/* Left Content (Text & Button) */}
//       <div className="w-full md:ml-20 md:w-1/2 text-center md:text-left space-y-5 relative z-10">
//         <h1 className="text-4xl md:text-7xl font-extrabold text-black">
//           TGHC
//         </h1>

//         <p className="uppercase tracking-widest text-honey-dark font-semibold text-lg">
//           Fresh & Sweet as Honey.
//         </p>
//         <p className=" text-black leading-relaxed text-xs md:text-lg font-medium max-w-lg mx-auto md:mx-0">
//           Enjoy the finest honey sourced from sustainable and ethical beekeeping practices.
//           Indulge in a variety of honey products, including raw, creamed, and flavored honey.
//         </p>

//         <button className="shop-now-btn p-3 md:p-4 md:ml-5   text-xs md:text-base" onClick={handleHomeClick}>
//           <span className="relative z-10">Shop Now</span>
//         </button>
//       </div>

//       {/* Right Section (Background Image on Mobile, Normal on Desktop) */}
//       <div className="w-full md:w-1/2 flex fadeInAnimation justify-center items-center relative">
//         {mainImageLottie && (
//           <div className="hidden md:block relative w-64 h-64 md:w-140 md:h-140">
//             <Lottie animationData={mainImageLottie} loop autoPlay />
//           </div>
//         )}
//       </div>

//       {/* Background Image for Mobile */}
//       {/* {mainImageLottie && (
//         <div className="absolute inset-0 md:hidden opacity-20 z-0">
//           <Lottie animationData={mainImageLottie} loop autoPlay />
//         </div>
//       )} */}

// {/* Background Lottie for All Screens */}
// {/* {mainImageLottie && (
//   <div className="absolute md:hidden  inset-0 z-0 opacity-30 fadeInAnimation">
//     <Lottie animationData={mainImageLottie} loop autoPlay />
//   </div>
// )} */}

// {mainImageLottie && (
//   <div style={{ opacity: 0.1 }} className="absolute md:hidden inset-0 z-0 opacity-[0.1] fadeInAnimation pointer-events-none">
//     <Lottie style={{ opacity: 0.3 }} animationData={mainImageLottie} loop autoPlay />

//   </div>
  
// )}



//       {/* Animated Bees */}
//       {beeAnimation1 && (
//         <div className="absolute bee-animation bee-path-1" style={{ top: "10%", left: "10%", width: "50px" }}>
//           <Lottie animationData={beeAnimation1} loop autoPlay />
//         </div>
//       )}
//       {beeAnimation2 && (
//         <div className="absolute bee-animation bee-path-2" style={{ top: "10%", left: "10%", width: "50px" }}>
//           <Lottie animationData={beeAnimation2} loop autoPlay />
//         </div>
//       )}
//       {beeAnimation3 && (
//         <div className="absolute bee-animation bee-path-3" style={{ top: "10%", left: "10%", width: "50px" }}>
//           <Lottie animationData={beeAnimation3} loop autoPlay />
//         </div>
//       )}

// <style jsx>{`


// @keyframes fadeIn {
//   0% {
//     opacity: 0;
//     transform: scale(0.8);
//   }
//   100% {
//     opacity: 1;
//     transform: scale(1);
//   }
// }

// .fadeInAnimation {
//   animation: fadeIn 1.5s ease-in forwards;
// }


//   .bg-cream {
//     background: #fdf5e6;
//   }



//   .bg-honey {
//     background-image: url('/assets/General/honeyDripTop.png');
//     background-size: contain;
//     height: 60px;
//   }

//   .bg-honey-gradient {
//     background: linear-gradient(45deg, #ffbb33, #ff9900, #ff6600);
//   }

//     /* Shop now button styles */
//         .shop-now-btn {
//           background: linear-gradient(45deg, #ff6b00 0%, rgb(245, 131, 0) 50%, #ff6b00 100%);
//           color: white;
//           font-weight: 600;
//           border-radius: 0.5rem;
//           overflow: hidden;
//           transition: all 0.4s ease;
//           box-shadow: 0 4px 15px rgba(255, 107, 0, 0.3);
//         }

//         .shop-now-btn:hover {
//           background-position: right center;
//           transform: translateY(-3px);
//           box-shadow: 0 6px 20px rgba(255, 107, 0, 0.4);
//         }

//   /* Bees move across the entire screen dynamically */
//   .bee-animation {
//     position: fixed;
//     animation-timing-function: ease-in-out;
//   }

//   /* Bee Path 1 - Top Left to Bottom Right */
//   .bee-path-1 {
//     animation: bee-fly-1 16s infinite  ;
//     top: 10vh;
//     left: -10vw;
//   }

//   /* Bee Path 2 - Bottom Left to Top Right */
//   .bee-path-2 {
//     animation: bee-fly-2 5s infinite  ;
//     top: 80vh;
//     left: -20vw;
//   }

//   /* Bee Path 3 - Zigzag Across the Screen */
//   .bee-path-3 {
//     animation: bee-fly-3 5s infinite  ;
//     top: 60vh;
//     left: 120vw;
//   }

//   @keyframes bee-fly-1 {
//     100% {
//             transform: translateX(90vw) translateY(80vh) rotate(30deg);

//     }
//     60% {
//       transform: translateX(40vw) translateY(-20vh) rotate(30deg);
//     }
//     30% {
//       transform: translateX(60vw) translateY(50vh) rotate(-45deg);
//     }
//     0% {
//     transform: translateX(-10vw) translateY(10vh) rotate(0deg);
//       opacity: 100;
//     }
//   }

//   @keyframes bee-fly-2 {
//     0% {
//       transform: translateX(-20vw) translateY(80vh) rotate(0deg);
//     }
//     25% {
//       transform: translateX(30vw) translateY(-20vh) rotate(-20deg);
//     }
//     50% {
//       transform: translateX(60vw) translateY(10vh) rotate(20deg);
//     }
//     75% {
//       transform: translateX(100vw) translateY(-10vh) rotate(-10deg);
//     }
//     100% {
//       transform: translateX(130vw) translateY(60vh) rotate(10deg);
//       opacity: 100;
//     }
//   }

//   @keyframes bee-fly-3 {
//     100% {
//       transform: translateX(120vw) translateY(50vh) rotate(0deg);
//     }
//     80% {
//       transform: translateX(80vw) translateY(-30vh) rotate(20deg);
//     }
//     60% {
//       transform: translateX(50vw) translateY(30vh) rotate(-30deg);
//     }
//     40% {
//       transform: translateX(20vw) translateY(-20vh) rotate(20deg);
//     }
//     20% {
//       transform: translateX(-10vw) translateY(10vh) rotate(-80deg);
//     }
//     0% {
//       transform: translateX(-30vw) translateY(-30vh) rotate(80deg);
//       opacity: 100;
//     }
//   }
// `}</style>
//  </div>
//   );
// };

// export default HeroSection;



import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";

const HeroSection = () => {
  const navigate = useNavigate();

  const handleHomeClick = () => {
    navigate("/shop");
  };

  // --- Lottie States ---
  const [beeAnimation1, setBeeAnimation1] = useState(null);
  const [beeAnimation2, setBeeAnimation2] = useState(null);
  const [beeAnimation3, setBeeAnimation3] = useState(null);
  const [mainImageLottie, setMainImageLottie] = useState(null);

  // --- Typing Effect States ---
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [headingText, setHeadingText] = useState("");
  const [subText, setSubText] = useState("");
  const [typingSpeed, setTypingSpeed] = useState(100);

  // --- Content Data ---
  const contentArray = [
    {
      heading: "Honey With a Heart.",
      subheading: "Each spoon supports thriving bees, stronger communities, and a sweeter world."
    },
    {
      heading: "From Our Hives to Your Home.",
      subheading: "Taste the honesty, feel the freshness, and bring home honey that truly makes a difference."
    },
    {
      heading: "Crafted by Bees, Cherished by Us.",
      subheading: "Every jar carries the care of our beekeepers and the quiet magic of nature."
    },
    {
      heading: "Purity You Can Feel.",
      subheading: "From hive to home, every drop is cared for, protected, and delivered just as nature intended."
    }
  ];

  // --- Fetch Lottie Assets ---
  useEffect(() => {
    const loadLottie = async (path, setter) => {
      try {
        const res = await fetch(path);
        const data = await res.json();
        setter(data);
      } catch (err) {
        console.error(`Error loading ${path}:`, err);
      }
    };

    loadLottie("/assets/General/honeyBee.json", setBeeAnimation1);
    loadLottie("/assets/General/honeyBee.json", setBeeAnimation2);
    loadLottie("/assets/General/honeyBee.json", setBeeAnimation3);
    loadLottie("/assets/General/homeBottom.json", setMainImageLottie);
  }, []);

  // --- Typing Logic ---
  useEffect(() => {
    const i = loopNum % contentArray.length;
    const fullHeading = contentArray[i].heading;
    const fullSub = contentArray[i].subheading;

    const handleTyping = () => {
      // 1. Check if we are deleting or typing
      if (isDeleting) {
        // DELETE PHASE
        // Delete subheading first
        if (subText.length > 0) {
          setSubText(fullSub.substring(0, subText.length - 1));
          setTypingSpeed(10); // Delete fast
        } 
        // Then delete heading
        else if (headingText.length > 0) {
          setHeadingText(fullHeading.substring(0, headingText.length - 1));
          setTypingSpeed(20);
        } else {
          // Both deleted, move to next slide
          setIsDeleting(false);
          setLoopNum(loopNum + 1);
          setTypingSpeed(150); // Reset start speed
        }
      } else {
        // TYPE PHASE
        // Type heading first
        if (headingText.length < fullHeading.length) {
          setHeadingText(fullHeading.substring(0, headingText.length + 1));
          setTypingSpeed(50); // Normal typing speed
        } 
        // Then type subheading
        else if (subText.length < fullSub.length) {
          setSubText(fullSub.substring(0, subText.length + 1));
          setTypingSpeed(30); // Type subheading faster
        } else {
          // Both fully typed, wait before deleting
          setIsDeleting(true);
          setTypingSpeed(3500); // Pause for 3 seconds to read
        }
      }
    };

    const timer = setTimeout(handleTyping, typingSpeed);
    return () => clearTimeout(timer);
  }, [headingText, subText, isDeleting, loopNum, typingSpeed]);

  return (
    <div className="relative mt-27 pb-10 md:pb-0 pt-5 md:pt-0 md:mt-0 md:min-h-screen bg-cream w-full flex flex-col md:flex-row items-center px-4 md:px-16 justify-between overflow-hidden">
      
      {/* Background Images for Laptop View */}
      <div className="hidden md:block">
        <img 
          src="/assets/General/leftBottom.png" 
          alt="Left Background" 
          className="absolute left-0 bottom-0 w-40 lg:w-60 fadeInAnimation"
        />
      </div>

      <div className="block md:hidden h-[20px] w-full"></div>

      {/* Left Content (Text & Button) */}
      <div className="w-full md:ml-20 md:w-1/2 text-center md:text-left space-y-5 relative z-10">
        
        <h1 className="text-4xl md:text-7xl font-extrabold text-black">
          TGHC
        </h1>

        {/* Dynamic Typing Container */}
        {/* Set min-height to prevent layout shift when text changes */}
        <div className="min-h-[180px] md:min-h-[160px] flex flex-col justify-start">
          <p className="uppercase tracking-widest text-honey-dark font-semibold text-lg min-h-[1.75rem]">
            {headingText}
            {/* Blinking cursor only shows when typing heading or when heading is done but sub isn't started */}
            {!isDeleting && subText.length === 0 && <span className="blinking-cursor">|</span>}
          </p>
          
          <p className="text-black leading-relaxed text-xs md:text-lg font-medium max-w-lg mx-auto md:mx-0 mt-2">
            {subText}
            {/* Blinking cursor moves to end of subtext */}
            {!isDeleting && subText.length > 0 && <span className="blinking-cursor">|</span>}
          </p>
        </div>

        <button className="shop-now-btn p-3 md:p-4 md:ml-5 text-xs md:text-base" onClick={handleHomeClick}>
          <span className="relative z-10">Shop Now</span>
        </button>
      </div>

      {/* Right Section (Lottie) */}
      <div className="w-full md:w-1/2 flex fadeInAnimation justify-center items-center relative">
        {mainImageLottie && (
          <div className="hidden md:block relative w-64 h-64 md:w-140 md:h-140">
            <Lottie animationData={mainImageLottie} loop autoPlay />
          </div>
        )}
      </div>

      {mainImageLottie && (
        <div style={{ opacity: 0.1 }} className="absolute md:hidden inset-0 z-0 opacity-[0.1] fadeInAnimation pointer-events-none">
          <Lottie style={{ opacity: 0.3 }} animationData={mainImageLottie} loop autoPlay />
        </div>
      )}

      {/* Animated Bees */}
      {beeAnimation1 && (
        <div className="absolute bee-animation bee-path-1" style={{ top: "10%", left: "10%", width: "50px" }}>
          <Lottie animationData={beeAnimation1} loop autoPlay />
        </div>
      )}
      {beeAnimation2 && (
        <div className="absolute bee-animation bee-path-2" style={{ top: "10%", left: "10%", width: "50px" }}>
          <Lottie animationData={beeAnimation2} loop autoPlay />
        </div>
      )}
      {beeAnimation3 && (
        <div className="absolute bee-animation bee-path-3" style={{ top: "10%", left: "10%", width: "50px" }}>
          <Lottie animationData={beeAnimation3} loop autoPlay />
        </div>
      )}

      <style jsx>{`
        @keyframes fadeIn {
          0% { opacity: 0; transform: scale(0.8); }
          100% { opacity: 1; transform: scale(1); }
        }

        @keyframes blink {
          0%, 100% { opacity: 1; }
          50% { opacity: 0; }
        }

        .fadeInAnimation {
          animation: fadeIn 1.5s ease-in forwards;
        }

        .blinking-cursor {
          color: #ff6b00;
          animation: blink 0.8s step-end infinite;
          font-weight: bold;
        }

        .bg-cream { background: #fdf5e6; }
        .text-honey-dark { color: #cc7700; } /* Fallback color definition if not in tailwind config */

        .shop-now-btn {
          background: linear-gradient(45deg, #ff6b00 0%, rgb(245, 131, 0) 50%, #ff6b00 100%);
          color: white;
          font-weight: 600;
          border-radius: 0.5rem;
          overflow: hidden;
          transition: all 0.4s ease;
          box-shadow: 0 4px 15px rgba(255, 107, 0, 0.3);
        }
        .shop-now-btn:hover {
          background-position: right center;
          transform: translateY(-3px);
          box-shadow: 0 6px 20px rgba(255, 107, 0, 0.4);
        }

        /* Bee Animations */
        .bee-animation { position: fixed; animation-timing-function: ease-in-out; }
        .bee-path-1 { animation: bee-fly-1 16s infinite; top: 10vh; left: -10vw; }
        .bee-path-2 { animation: bee-fly-2 5s infinite; top: 80vh; left: -20vw; }
        .bee-path-3 { animation: bee-fly-3 5s infinite; top: 60vh; left: 120vw; }

        @keyframes bee-fly-1 {
          100% { transform: translateX(90vw) translateY(80vh) rotate(30deg); }
          60% { transform: translateX(40vw) translateY(-20vh) rotate(30deg); }
          30% { transform: translateX(60vw) translateY(50vh) rotate(-45deg); }
          0% { transform: translateX(-10vw) translateY(10vh) rotate(0deg); opacity: 100; }
        }
        @keyframes bee-fly-2 {
          0% { transform: translateX(-20vw) translateY(80vh) rotate(0deg); }
          25% { transform: translateX(30vw) translateY(-20vh) rotate(-20deg); }
          50% { transform: translateX(60vw) translateY(10vh) rotate(20deg); }
          75% { transform: translateX(100vw) translateY(-10vh) rotate(-10deg); }
          100% { transform: translateX(130vw) translateY(60vh) rotate(10deg); opacity: 100; }
        }
        @keyframes bee-fly-3 {
          100% { transform: translateX(120vw) translateY(50vh) rotate(0deg); }
          80% { transform: translateX(80vw) translateY(-30vh) rotate(20deg); }
          60% { transform: translateX(50vw) translateY(30vh) rotate(-30deg); }
          40% { transform: translateX(20vw) translateY(-20vh) rotate(20deg); }
          20% { transform: translateX(-10vw) translateY(10vh) rotate(-80deg); }
          0% { transform: translateX(-30vw) translateY(-30vh) rotate(80deg); opacity: 100; }
        }
      `}</style>
    </div>
  );
};

export default HeroSection;